import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import styled from 'styled-components';
import { get } from '../../styles/constant';
import Input from '../Input';
import { inputFit, inputVariant, inputErrorFocusVariant, inputFocusVariant, paddingVariant, BasicInputStyle } from '../../styles/FormElements';
const variants = {
  inputFit,
  inputVariant,
  inputErrorFocusVariant,
  inputFocusVariant,
  paddingVariant
};
const Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex: 1 1 100%;\n  ", "\n  ", "\n  ", "\n  padding: 0;\n  border-color: ", ";\n  overflow: hidden;\n"])), variants.inputFit, variants.inputVariant, BasicInputStyle, props => props.error ? get('colors.feedback.danger.normal') : get('colors.functional.grey.400'));
const AppendGroup = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
const PrependGroup = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));
const InputElement = styled(Input)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  border: 0;\n\n  &:focus {\n    outline: 0;\n    box-shadow: none;\n  }\n"])));
const Components = {
  AppendGroup,
  InputElement,
  PrependGroup,
  Wrapper
};
export { Components };